import React, { useState } from 'react';
import {
  FDBodyText, FDHeadlineText, FDPaper, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import { BorderedTransparentBox } from 'Packages/FacetDesign/Components/Experimental/BorderedTransparentBox';

const metaOverride = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDBodyText,
    _customProps: { size: 'md', color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride(['value'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly);

const MoneyFlowDetail = ({
  resource,
}) => {
  const {
    loadModalCollectionByLink,
  } = useModalContext();
  const isMobile = useMobileLayout();
  const { displayErrorMessage } = useSnackbarContext();
  const [loading, setLoading] = useState(false);

  const handleOpen = async (rel) => {
    try {
      setLoading(true);
      await loadModalCollectionByLink(rel.link('related').url());
      setLoading(false);
    } catch (err) {
      displayErrorMessage('Unable to open details');
      setLoading(false);
    }
  };
  return (
    <>
      {/* This is a bit of a hack, but I'm using a BorderedTransparentBox with an FDPaper in order to create a box with a
      subtle background color that is not transparent. This approach is preferable to setting the background color on the
      box manually via CSS because using the FDPaper allows FD to maintain control of the palette for the downstream components.
      In this case, FDPaper will internally set the palette to 'subtle' which will then ensure we use the proper color palette. */}
      <BorderedTransparentBox color={'info'} {...dataAttrs('money-flow-detail')}>
        <FDPaper color={'subtle'} padding={2} width={isMobile ? '100%' : '300px'} appearance={'flat'}>
          <FDStack height={'100%'} direction={'column'} justifyContent={'center'} spacing={1}>
            <MetaControl resource={resource} attrName={'title'} metaOverrideSet={metaOverride} />
            <MetaControl resource={resource} attrName={'value'} metaOverrideSet={metaOverride} />
            {resource.withRelationship(fr.relationships.details.name,
              (rel) => (
                <FDPrimaryActionButton
                  loading={loading}
                  label={rel.meta('prompt')}
                  onClick={() => handleOpen(rel)}
                  {...dataAttrs('money-flow-detail-button')}
                />
              ),
              () => null)}
          </FDStack>

        </FDPaper>
      </BorderedTransparentBox>
    </>
  );
};

MoneyFlowDetail.defaultProps = {};

MoneyFlowDetail.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default MoneyFlowDetail;
